/* tslint:disable */
/* eslint-disable */
/**
 * New Train Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, RequiredError } from '../base';
// @ts-ignore
import { GetAvailableResultEx } from '../model';
// @ts-ignore
import { GetAvailableStatus } from '../model';
// @ts-ignore
import { GetNearbyRoutesRequest } from '../model';
// @ts-ignore
import { GetNearbyRoutesResult } from '../model';
// @ts-ignore
import { MidStationResponse } from '../model';
// @ts-ignore
import { NearbyAirportsResponse } from '../model';
// @ts-ignore
import { PostAvailableRequest } from '../model';
// @ts-ignore
import { ProblemDetails } from '../model';
// @ts-ignore
import { TrainAvailabilityResponse } from '../model';
// @ts-ignore
import { UpdateTrainPreSaleDateRequest } from '../model';
/**
 * TrainApiApiCheckAvailableGet - axios parameter creator
 * 
 * @summary Check Available trains
 * @param {number} from 
 * @param {number} to 
 * @param {string} date 
 * @param {number} [genderCode] 
 * @param {number} [adultCount] 
 * @param {number} [childCount] 
 * @param {number} [infantCount] 
 * @param {boolean} [disableCache] 
 * @param {boolean} [exclusive] 
 * @param {GetAvailableStatus} [availableStatus] 
 * @param {number} [selectedCapacityId] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function TrainApiApiCheckAvailableGetAxiosParamCreator (from: number, to: number, date: string, genderCode?: number, adultCount?: number, childCount?: number, infantCount?: number, disableCache?: boolean, exclusive?: boolean, availableStatus?: GetAvailableStatus, selectedCapacityId?: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'from' is not null or undefined
    assertParamExists('apiCheckAvailableGet', 'from', from)
    // verify required parameter 'to' is not null or undefined
    assertParamExists('apiCheckAvailableGet', 'to', to)
    // verify required parameter 'date' is not null or undefined
    assertParamExists('apiCheckAvailableGet', 'date', date)
    const localVarPath = `/api/CheckAvailable`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (from !== undefined) {
        localVarQueryParameter['from'] = from;
    }

    if (to !== undefined) {
        localVarQueryParameter['to'] = to;
    }

    if (date !== undefined) {
        localVarQueryParameter['date'] = (date as any instanceof Date) ?
            (date as any).toISOString() :
            date;
    }

    if (genderCode !== undefined) {
        localVarQueryParameter['genderCode'] = genderCode;
    }

    if (adultCount !== undefined) {
        localVarQueryParameter['adultCount'] = adultCount;
    }

    if (childCount !== undefined) {
        localVarQueryParameter['childCount'] = childCount;
    }

    if (infantCount !== undefined) {
        localVarQueryParameter['infantCount'] = infantCount;
    }

    if (disableCache !== undefined) {
        localVarQueryParameter['disableCache'] = disableCache;
    }

    if (exclusive !== undefined) {
        localVarQueryParameter['exclusive'] = exclusive;
    }

    if (availableStatus !== undefined) {
        localVarQueryParameter['availableStatus'] = availableStatus;
    }

    if (selectedCapacityId !== undefined) {
        localVarQueryParameter['selectedCapacityId'] = selectedCapacityId;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * TrainApiApiGetAllTrainStationsGet - axios parameter creator
 * 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function TrainApiApiGetAllTrainStationsGetAxiosParamCreator (options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/GetAllTrainStations`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * TrainApiApiGetAvailableGet - axios parameter creator
 * 
 * @summary The old getter
 * @param {string} [xPlayerid] 
 * @param {string} [authorization] 
 * @param {number} [from] 
 * @param {number} [to] 
 * @param {string} [date] 
 * @param {number} [genderCode] 
 * @param {number} [adultCount] 
 * @param {number} [childCount] 
 * @param {boolean} [disableCache] 
 * @param {boolean} [exclusive] 
 * @param {boolean} [includeExtendedData] 
 * @param {number} [pageSize] 
 * @param {number} [pageNo] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function TrainApiApiGetAvailableGetAxiosParamCreator (xPlayerid?: string, authorization?: string, from?: number, to?: number, date?: string, genderCode?: number, adultCount?: number, childCount?: number, disableCache?: boolean, exclusive?: boolean, includeExtendedData?: boolean, pageSize?: number, pageNo?: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/GetAvailable`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (from !== undefined) {
        localVarQueryParameter['From'] = from;
    }

    if (to !== undefined) {
        localVarQueryParameter['To'] = to;
    }

    if (date !== undefined) {
        localVarQueryParameter['Date'] = (date as any instanceof Date) ?
            (date as any).toISOString() :
            date;
    }

    if (genderCode !== undefined) {
        localVarQueryParameter['GenderCode'] = genderCode;
    }

    if (adultCount !== undefined) {
        localVarQueryParameter['AdultCount'] = adultCount;
    }

    if (childCount !== undefined) {
        localVarQueryParameter['ChildCount'] = childCount;
    }

    if (disableCache !== undefined) {
        localVarQueryParameter['DisableCache'] = disableCache;
    }

    if (exclusive !== undefined) {
        localVarQueryParameter['Exclusive'] = exclusive;
    }

    if (includeExtendedData !== undefined) {
        localVarQueryParameter['IncludeExtendedData'] = includeExtendedData;
    }

    if (pageSize !== undefined) {
        localVarQueryParameter['PageSize'] = pageSize;
    }

    if (pageNo !== undefined) {
        localVarQueryParameter['PageNo'] = pageNo;
    }

    if (xPlayerid != null) {
        localVarHeaderParameter['x-playerid'] = String(xPlayerid);
    }

    if (authorization != null) {
        localVarHeaderParameter['Authorization'] = String(authorization);
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * TrainApiApiGetAvailablePost - axios parameter creator
 * 
 * @summary The old getter, supporting filterting and sorting along with pagination
 * @param {string} [authorization] 
 * @param {string} [xPlayerid] 
 * @param {PostAvailableRequest} [postAvailableRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function TrainApiApiGetAvailablePostAxiosParamCreator (authorization?: string, xPlayerid?: string, postAvailableRequest?: PostAvailableRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/GetAvailable`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (authorization != null) {
        localVarHeaderParameter['Authorization'] = String(authorization);
    }

    if (xPlayerid != null) {
        localVarHeaderParameter['x-playerid'] = String(xPlayerid);
    }



    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(postAvailableRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * TrainApiApiGetAvailableV2Get - axios parameter creator
 * 
 * @summary get Available trains
 * @param {number} from 
 * @param {number} to 
 * @param {string} date 
 * @param {string} [authorization] 
 * @param {string} [xPlayerid] 
 * @param {number} [genderCode] 
 * @param {number} [adultCount] 
 * @param {number} [childCount] 
 * @param {number} [infantCount] 
 * @param {boolean} [disableCache] 
 * @param {boolean} [exclusive] 
 * @param {GetAvailableStatus} [availableStatus] 
 * @param {number} [selectedCapacityId] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function TrainApiApiGetAvailableV2GetAxiosParamCreator (from: number, to: number, date: string, authorization?: string, xPlayerid?: string, genderCode?: number, adultCount?: number, childCount?: number, infantCount?: number, disableCache?: boolean, exclusive?: boolean, availableStatus?: GetAvailableStatus, selectedCapacityId?: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'from' is not null or undefined
    assertParamExists('apiGetAvailableV2Get', 'from', from)
    // verify required parameter 'to' is not null or undefined
    assertParamExists('apiGetAvailableV2Get', 'to', to)
    // verify required parameter 'date' is not null or undefined
    assertParamExists('apiGetAvailableV2Get', 'date', date)
    const localVarPath = `/api/GetAvailable/v2`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (from !== undefined) {
        localVarQueryParameter['from'] = from;
    }

    if (to !== undefined) {
        localVarQueryParameter['to'] = to;
    }

    if (date !== undefined) {
        localVarQueryParameter['date'] = (date as any instanceof Date) ?
            (date as any).toISOString() :
            date;
    }

    if (genderCode !== undefined) {
        localVarQueryParameter['genderCode'] = genderCode;
    }

    if (adultCount !== undefined) {
        localVarQueryParameter['adultCount'] = adultCount;
    }

    if (childCount !== undefined) {
        localVarQueryParameter['childCount'] = childCount;
    }

    if (infantCount !== undefined) {
        localVarQueryParameter['infantCount'] = infantCount;
    }

    if (disableCache !== undefined) {
        localVarQueryParameter['disableCache'] = disableCache;
    }

    if (exclusive !== undefined) {
        localVarQueryParameter['exclusive'] = exclusive;
    }

    if (availableStatus !== undefined) {
        localVarQueryParameter['availableStatus'] = availableStatus;
    }

    if (selectedCapacityId !== undefined) {
        localVarQueryParameter['selectedCapacityId'] = selectedCapacityId;
    }

    if (authorization != null) {
        localVarHeaderParameter['Authorization'] = String(authorization);
    }

    if (xPlayerid != null) {
        localVarHeaderParameter['x-playerid'] = String(xPlayerid);
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * TrainApiApiGetNearbyRoutesPost - axios parameter creator
 * 
 * @summary Get Near by Routes
 * @param {GetNearbyRoutesRequest} [getNearbyRoutesRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function TrainApiApiGetNearbyRoutesPostAxiosParamCreator (getNearbyRoutesRequest?: GetNearbyRoutesRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/GetNearbyRoutes`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(getNearbyRoutesRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * TrainApiApiMidStationTrainCapacityIdGet - axios parameter creator
 * 
 * @summary Get mid stations
 * @param {number} trainCapacityId 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function TrainApiApiMidStationTrainCapacityIdGetAxiosParamCreator (trainCapacityId: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'trainCapacityId' is not null or undefined
    assertParamExists('apiMidStationTrainCapacityIdGet', 'trainCapacityId', trainCapacityId)
    const localVarPath = `/api/MidStation/{trainCapacityId}`
        .replace(`{${"trainCapacityId"}}`, encodeURIComponent(String(trainCapacityId)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * TrainApiApiNearbyWithIpGet - axios parameter creator
 * 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function TrainApiApiNearbyWithIpGetAxiosParamCreator (options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/NearbyWithIp`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * TrainApiApiTrainPreSaleDateGet - axios parameter creator
 * 
 * @summary get train preSaleDate
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function TrainApiApiTrainPreSaleDateGetAxiosParamCreator (options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/Train/PreSaleDate`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * TrainApiApiTrainPreSaleDatePatch - axios parameter creator
 * 
 * @summary Update train preSaleDate
 * @param {UpdateTrainPreSaleDateRequest} [updateTrainPreSaleDateRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function TrainApiApiTrainPreSaleDatePatchAxiosParamCreator (updateTrainPreSaleDateRequest?: UpdateTrainPreSaleDateRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/Train/PreSaleDate`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(updateTrainPreSaleDateRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}

/**
 * Request parameters for apiCheckAvailableGet operation in TrainApi.
 * @export
 * @interface TrainApiApiCheckAvailableGetRequest
 */
export interface TrainApiApiCheckAvailableGetRequest {
    /**
     * 
     * @type {number}
     * @memberof TrainApiApiCheckAvailableGet
     */
    readonly from: number

    /**
     * 
     * @type {number}
     * @memberof TrainApiApiCheckAvailableGet
     */
    readonly to: number

    /**
     * 
     * @type {string}
     * @memberof TrainApiApiCheckAvailableGet
     */
    readonly date: string

    /**
     * 
     * @type {number}
     * @memberof TrainApiApiCheckAvailableGet
     */
    readonly genderCode?: number

    /**
     * 
     * @type {number}
     * @memberof TrainApiApiCheckAvailableGet
     */
    readonly adultCount?: number

    /**
     * 
     * @type {number}
     * @memberof TrainApiApiCheckAvailableGet
     */
    readonly childCount?: number

    /**
     * 
     * @type {number}
     * @memberof TrainApiApiCheckAvailableGet
     */
    readonly infantCount?: number

    /**
     * 
     * @type {boolean}
     * @memberof TrainApiApiCheckAvailableGet
     */
    readonly disableCache?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof TrainApiApiCheckAvailableGet
     */
    readonly exclusive?: boolean

    /**
     * 
     * @type {GetAvailableStatus}
     * @memberof TrainApiApiCheckAvailableGet
     */
    readonly availableStatus?: GetAvailableStatus

    /**
     * 
     * @type {number}
     * @memberof TrainApiApiCheckAvailableGet
     */
    readonly selectedCapacityId?: number
}

/**
 * Request parameters for apiGetAvailableGet operation in TrainApi.
 * @export
 * @interface TrainApiApiGetAvailableGetRequest
 */
export interface TrainApiApiGetAvailableGetRequest {
    /**
     * 
     * @type {string}
     * @memberof TrainApiApiGetAvailableGet
     */
    readonly xPlayerid?: string

    /**
     * 
     * @type {string}
     * @memberof TrainApiApiGetAvailableGet
     */
    readonly authorization?: string

    /**
     * 
     * @type {number}
     * @memberof TrainApiApiGetAvailableGet
     */
    readonly from?: number

    /**
     * 
     * @type {number}
     * @memberof TrainApiApiGetAvailableGet
     */
    readonly to?: number

    /**
     * 
     * @type {string}
     * @memberof TrainApiApiGetAvailableGet
     */
    readonly date?: string

    /**
     * 
     * @type {number}
     * @memberof TrainApiApiGetAvailableGet
     */
    readonly genderCode?: number

    /**
     * 
     * @type {number}
     * @memberof TrainApiApiGetAvailableGet
     */
    readonly adultCount?: number

    /**
     * 
     * @type {number}
     * @memberof TrainApiApiGetAvailableGet
     */
    readonly childCount?: number

    /**
     * 
     * @type {boolean}
     * @memberof TrainApiApiGetAvailableGet
     */
    readonly disableCache?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof TrainApiApiGetAvailableGet
     */
    readonly exclusive?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof TrainApiApiGetAvailableGet
     */
    readonly includeExtendedData?: boolean

    /**
     * 
     * @type {number}
     * @memberof TrainApiApiGetAvailableGet
     */
    readonly pageSize?: number

    /**
     * 
     * @type {number}
     * @memberof TrainApiApiGetAvailableGet
     */
    readonly pageNo?: number
}

/**
 * Request parameters for apiGetAvailablePost operation in TrainApi.
 * @export
 * @interface TrainApiApiGetAvailablePostRequest
 */
export interface TrainApiApiGetAvailablePostRequest {
    /**
     * 
     * @type {string}
     * @memberof TrainApiApiGetAvailablePost
     */
    readonly authorization?: string

    /**
     * 
     * @type {string}
     * @memberof TrainApiApiGetAvailablePost
     */
    readonly xPlayerid?: string

    /**
     * 
     * @type {PostAvailableRequest}
     * @memberof TrainApiApiGetAvailablePost
     */
    readonly postAvailableRequest?: PostAvailableRequest
}

/**
 * Request parameters for apiGetAvailableV2Get operation in TrainApi.
 * @export
 * @interface TrainApiApiGetAvailableV2GetRequest
 */
export interface TrainApiApiGetAvailableV2GetRequest {
    /**
     * 
     * @type {number}
     * @memberof TrainApiApiGetAvailableV2Get
     */
    readonly from: number

    /**
     * 
     * @type {number}
     * @memberof TrainApiApiGetAvailableV2Get
     */
    readonly to: number

    /**
     * 
     * @type {string}
     * @memberof TrainApiApiGetAvailableV2Get
     */
    readonly date: string

    /**
     * 
     * @type {string}
     * @memberof TrainApiApiGetAvailableV2Get
     */
    readonly authorization?: string

    /**
     * 
     * @type {string}
     * @memberof TrainApiApiGetAvailableV2Get
     */
    readonly xPlayerid?: string

    /**
     * 
     * @type {number}
     * @memberof TrainApiApiGetAvailableV2Get
     */
    readonly genderCode?: number

    /**
     * 
     * @type {number}
     * @memberof TrainApiApiGetAvailableV2Get
     */
    readonly adultCount?: number

    /**
     * 
     * @type {number}
     * @memberof TrainApiApiGetAvailableV2Get
     */
    readonly childCount?: number

    /**
     * 
     * @type {number}
     * @memberof TrainApiApiGetAvailableV2Get
     */
    readonly infantCount?: number

    /**
     * 
     * @type {boolean}
     * @memberof TrainApiApiGetAvailableV2Get
     */
    readonly disableCache?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof TrainApiApiGetAvailableV2Get
     */
    readonly exclusive?: boolean

    /**
     * 
     * @type {GetAvailableStatus}
     * @memberof TrainApiApiGetAvailableV2Get
     */
    readonly availableStatus?: GetAvailableStatus

    /**
     * 
     * @type {number}
     * @memberof TrainApiApiGetAvailableV2Get
     */
    readonly selectedCapacityId?: number
}

/**
 * Request parameters for apiGetNearbyRoutesPost operation in TrainApi.
 * @export
 * @interface TrainApiApiGetNearbyRoutesPostRequest
 */
export interface TrainApiApiGetNearbyRoutesPostRequest {
    /**
     * 
     * @type {GetNearbyRoutesRequest}
     * @memberof TrainApiApiGetNearbyRoutesPost
     */
    readonly getNearbyRoutesRequest?: GetNearbyRoutesRequest
}

/**
 * Request parameters for apiMidStationTrainCapacityIdGet operation in TrainApi.
 * @export
 * @interface TrainApiApiMidStationTrainCapacityIdGetRequest
 */
export interface TrainApiApiMidStationTrainCapacityIdGetRequest {
    /**
     * 
     * @type {number}
     * @memberof TrainApiApiMidStationTrainCapacityIdGet
     */
    readonly trainCapacityId: number
}

/**
 * Request parameters for apiTrainPreSaleDatePatch operation in TrainApi.
 * @export
 * @interface TrainApiApiTrainPreSaleDatePatchRequest
 */
export interface TrainApiApiTrainPreSaleDatePatchRequest {
    /**
     * 
     * @type {UpdateTrainPreSaleDateRequest}
     * @memberof TrainApiApiTrainPreSaleDatePatch
     */
    readonly updateTrainPreSaleDateRequest?: UpdateTrainPreSaleDateRequest
}

/**
* 
* @summary Check Available trains
* @param {TrainApiApiCheckAvailableGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function TrainApiApiCheckAvailableGet(requestParameters: TrainApiApiCheckAvailableGetRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await TrainApiApiCheckAvailableGetAxiosParamCreator(requestParameters.from, requestParameters.to, requestParameters.date, requestParameters.genderCode, requestParameters.adultCount, requestParameters.childCount, requestParameters.infantCount, requestParameters.disableCache, requestParameters.exclusive, requestParameters.availableStatus, requestParameters.selectedCapacityId, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function TrainApiApiGetAllTrainStationsGet(options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await TrainApiApiGetAllTrainStationsGetAxiosParamCreator(options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary The old getter
* @param {TrainApiApiGetAvailableGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function TrainApiApiGetAvailableGet(requestParameters: TrainApiApiGetAvailableGetRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await TrainApiApiGetAvailableGetAxiosParamCreator(requestParameters.xPlayerid, requestParameters.authorization, requestParameters.from, requestParameters.to, requestParameters.date, requestParameters.genderCode, requestParameters.adultCount, requestParameters.childCount, requestParameters.disableCache, requestParameters.exclusive, requestParameters.includeExtendedData, requestParameters.pageSize, requestParameters.pageNo, options, configuration);
    const request: () => AxiosPromise<GetAvailableResultEx> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary The old getter, supporting filterting and sorting along with pagination
* @param {TrainApiApiGetAvailablePostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function TrainApiApiGetAvailablePost(requestParameters: TrainApiApiGetAvailablePostRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await TrainApiApiGetAvailablePostAxiosParamCreator(requestParameters.authorization, requestParameters.xPlayerid, requestParameters.postAvailableRequest, options, configuration);
    const request: () => AxiosPromise<GetAvailableResultEx> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary get Available trains
* @param {TrainApiApiGetAvailableV2GetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function TrainApiApiGetAvailableV2Get(requestParameters: TrainApiApiGetAvailableV2GetRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await TrainApiApiGetAvailableV2GetAxiosParamCreator(requestParameters.from, requestParameters.to, requestParameters.date, requestParameters.authorization, requestParameters.xPlayerid, requestParameters.genderCode, requestParameters.adultCount, requestParameters.childCount, requestParameters.infantCount, requestParameters.disableCache, requestParameters.exclusive, requestParameters.availableStatus, requestParameters.selectedCapacityId, options, configuration);
    const request: () => AxiosPromise<TrainAvailabilityResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary Get Near by Routes
* @param {TrainApiApiGetNearbyRoutesPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function TrainApiApiGetNearbyRoutesPost(requestParameters: TrainApiApiGetNearbyRoutesPostRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await TrainApiApiGetNearbyRoutesPostAxiosParamCreator(requestParameters.getNearbyRoutesRequest, options, configuration);
    const request: () => AxiosPromise<GetNearbyRoutesResult> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary Get mid stations
* @param {TrainApiApiMidStationTrainCapacityIdGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function TrainApiApiMidStationTrainCapacityIdGet(requestParameters: TrainApiApiMidStationTrainCapacityIdGetRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await TrainApiApiMidStationTrainCapacityIdGetAxiosParamCreator(requestParameters.trainCapacityId, options, configuration);
    const request: () => AxiosPromise<Array<MidStationResponse>> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function TrainApiApiNearbyWithIpGet(options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await TrainApiApiNearbyWithIpGetAxiosParamCreator(options, configuration);
    const request: () => AxiosPromise<Array<NearbyAirportsResponse>> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary get train preSaleDate
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function TrainApiApiTrainPreSaleDateGet(options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await TrainApiApiTrainPreSaleDateGetAxiosParamCreator(options, configuration);
    const request: () => AxiosPromise<string> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary Update train preSaleDate
* @param {TrainApiApiTrainPreSaleDatePatchRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function TrainApiApiTrainPreSaleDatePatch(requestParameters: TrainApiApiTrainPreSaleDatePatchRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await TrainApiApiTrainPreSaleDatePatchAxiosParamCreator(requestParameters.updateTrainPreSaleDateRequest, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
